<template>
    <div class="profile-about-description" :class="descriptionOpen === true ? 'profile-about-description--open': '' ">
        <div class="profile-about-description__header">
            {{$store.getters.t('organizations_description_title')}}
        </div>
        <div class="profile-about-description__body">
            <div class="profile-about-description__body-content" v-text="organization.description"></div>
            <a v-if="organization.description.length > 354" href="#" class="profile-about-description__body-more"
               @click.prevent="descriptionOpen = !descriptionOpen">{{$store.getters.t('organizations_description_toggle')}}</a>
        </div>
    </div>
</template>

<script>
export default {
    props:['organization'],
    name: "OrganizationDescription",

    data(){
        return{
            descriptionOpen: false,
        }
    },
}
</script>

<style scoped>

</style>
